/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { gnoment } from 'shared-ui/gnoment';
import { Icon } from 'sarsaparilla';
import uniqBy from 'lodash/uniqBy';

import { DATE_FORMAT_US_SLASHES } from 'ui-camping/src/shared/constants';
import { getPrice } from '../utils';
import { PassTypeProps } from '../props';

export default class PassRateTable extends Component {
    static defaultProps = {
        passTypes: [],
        sortFn: (a, b) =>
            parseFloat(getPrice(b.periods).replace(/\/.*|\D/g, ' ')) -
            parseFloat(getPrice(a.periods).replace(/\/.*|\D/g, ' ')),
    };

    static propTypes = {
        passTypes: PropTypes.arrayOf(PassTypeProps),
        sortFn: PropTypes.func,
    };

    state = {
        isOpen: false,
    };

    toggleOpen = () => this.setState(({ isOpen }) => ({ isOpen: !isOpen }));

    render() {
        const { passTypes } = this.props;
        const { isOpen } = this.state;
        const periods = passTypes
            .flatMap((passType) => passType.periods)
            .filter((i) => i)
            .filter((i) => gnoment().isBefore(gnoment(i.start_date)));
        const startDates = uniqBy(periods, 'start_date')
            .map(({ start_date: start }) => start)
            .sort();

        const futurePassTypes = passTypes.filter((i) =>
            i.periods.some((j) => gnoment().isBefore(gnoment(j.start_date)))
        );

        if (startDates.length < 1) {
            return null;
        }

        return (
            <div className="parkpass-pass-rates">
                <div
                    className="parkpass-pass-rates-increases"
                    role="button"
                    tabIndex="0"
                    onClick={this.toggleOpen}
                    onKeyDown={(event) => {
                        if (
                            event.code === 'Space' ||
                            event.code === 'Enter' ||
                            event.which === '32' ||
                            event.which === '13'
                        ) {
                            event.preventDefault();
                            this.toggleOpen();
                        }
                    }}
                >
                    {isOpen ? (
                        <Icon iconName="chevron-up" />
                    ) : (
                        <Icon iconName="chevron-down" />
                    )}
                    Pass Rates - See upcoming price increases
                </div>

                {isOpen && (
                    <div className="parkpass-pass-types-table-wrapper">
                        <table className="parkpass-pass-types-table parkpass-pass-rates-table">
                            <thead>
                                <tr>
                                    <th>&nbsp;YEARLY RATES</th>
                                    {startDates.map((startDate) => (
                                        <th key={startDate}>
                                            {gnoment(startDate)
                                                .format(DATE_FORMAT_US_SLASHES)
                                                .replace(/^01\/01\//, '')}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {futurePassTypes
                                    .sort(this.props.sortFn)
                                    .map((passType) => {
                                        let previousPrice = '';
                                        return (
                                            <tr key={`pass-rate-row-${passType.id}`}>
                                                <td>{passType.name}</td>
                                                {startDates.map((startDate, i) => {
                                                    const period = passType.periods.find(
                                                        ({ start_date: start }) =>
                                                            start === startDate
                                                    );
                                                    const price = period
                                                        ? getPrice(
                                                              [period],
                                                              startDate,
                                                              true
                                                          )
                                                        : previousPrice;
                                                    previousPrice = price;

                                                    const formattedPrice = period
                                                        ? price
                                                        : previousPrice;

                                                    return (
                                                        <td
                                                            key={`pass-rate-col-${passType.id}-${i}`}
                                                        >
                                                            {formattedPrice}
                                                        </td>
                                                    );
                                                })}
                                            </tr>
                                        );
                                    })}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        );
    }
}

// cspell:ignore parkpass
